import { FC } from "react";

import { blockchain } from "../../settings";
import { useStoreSelector } from "../../store/store";
import { WithdrawReq } from "../../utils/Chromia/operations";
import { toFixed, updateDeposits } from "../../utils/helpers";

import Button from "../UI/Button/Button";
import WalletIcon from "../../assets/WalletIcon";

import './DepositsBlock.scss';


const DepositBlock: FC = () => {

	const {discountPercent, userAddress, appContracts, deposits} = useStoreSelector(store => store.app);
	const {deposits: chrDeposits} = useStoreSelector(store => store.chromia);

	const withdrawDeposit = async (depositId: number) => {
		if (!userAddress || !appContracts[discountPercent]) throw new Error('');

		/* const receipt = */ await appContracts[discountPercent]!.methods.Withdraw(depositId).send({from: userAddress, gas: 3000000, gasPrice: '5000000000'});

		setTimeout(() => {
			updateDeposits(discountPercent);
		}, 1000);
	}

	const chrWithdrawRequest = async (period: number) => {
		WithdrawReq(period)
	}


	switch (blockchain) {
		case 'binance':
			return (
				<div className="DepositsBlock">
					{deposits[discountPercent]?.length === 0?
						<div className="DepositsBlock-title">
							You don't have deposits
						</div>
					:
						<table>
							<thead>
								<tr>
									<td>Deposited</td>
									<td>ROI</td>
									<td>Balance</td>
									<td>Date</td>
									<td>Purchase Price</td>
									<td>Start Price</td>
								</tr>
							</thead>
							<tbody>
								{deposits[discountPercent].map(deposit => 
									<tr key={deposit.response.period + '_' + deposit.response.id}>
										<td>+{deposit.gainPercent}%</td>
										<td>{deposit.fTokenAmount} USDT {/* change this */}</td>
										<td>Deposited: {deposit.depositAmount} USDT</td>
										<td>CHR: {/* change this*/} {deposit.uTokenAmount}</td>
										<td>Purchase date: {/* change this*/} {deposit.depositDate}</td>
										<td>Purchase price: {/* change this*/} {deposit.purchasePrice}</td>
										<td>Start price: {/* change this*/} {deposit.startPrice}</td>
										{deposit.isWithdrawAvailable &&
											<Button
												action={() => withdrawDeposit(deposit.response.id)}
											>
												Withdraw
											</Button>
										}
									</tr>
								)}
							</tbody>
						</table>
					}
				</div>
			)

		case 'chromia':
			return (
				<div className="DepositsBlock">
					{chrDeposits[discountPercent].length === 0?
						<div className="DepositsBlock-title">
							You don't have deposits
						</div>
					:
						<table>
							<thead>
								<tr>
									<td/>
									<td>Deposited</td>
									{/* <td>ROI</td>
									<td>Balance</td>
									<td>Date</td>
									<td>Purchase Price</td> */}
									<td>Start Price</td>
									<td></td>
								</tr>
							</thead>
							<tbody>
								{chrDeposits[discountPercent].map((deposit, index) => 
									<tr key={index + '_' + deposit.period}>
										<td className="first_td"><WalletIcon/></td>
										<td>
											<span className="DepositsBlock-textGradient">{deposit.depositAmount}</span> USDT
										</td>
										{/* <td>
											<span className="DepositsBlock-textGradient">+0</span>%
										</td>
										<td>
											<div>
												<span className="DepositsBlock-textGradient">-</span> USDT
											</div>
											<div>
												<span className="DepositsBlock-textGradient">-</span> CHR
											</div>
										</td>
										<td>-/-/-</td>
										<td>-</td> */}
										<td>
											<span className="DepositsBlock-textGradient">{+toFixed(deposit.startPrice, 2)}</span> USDT
										</td>
										<td  className="last_td">
											{deposit.isWithdrawAvailable &&
												<Button
													action={() => deposit.period && chrWithdrawRequest(deposit.period)}
													className="last_td-button"
												>
													Withdraw
												</Button>
											}
										</td>
									</tr>
								)}
							</tbody>
						</table>
					}
				</div>
			)
	
		default:
			return null
	}
}

export default DepositBlock;